import gsap from "gsap";

export default function BlogSignUpModalHandler() {
    if (document.querySelector('#blog-signup-popup')) {
        const signupmodal = document.querySelector('#blog-signup-popup');
        const closemodal = document.querySelectorAll('.signup-close');

        gsap.set(signupmodal, {
            autoAlpha: 0
        });

        closemodal.forEach(close => {
            close.addEventListener('click', function () {
                gsap.to(signupmodal, {
                    autoAlpha: 0,
                    duration: 0.3
                });
            });
        });
        document.querySelector('body').addEventListener('mouseleave',function(){
            gsap.to(signupmodal, {
                autoAlpha: 1,
                duration: 0.3
            });
        })
    }
}
